import { render } from "./LegacyOccupancyReportSettings.vue?vue&type=template&id=a3e7b41e"
import script from "./LegacyOccupancyReportSettings.vue?vue&type=script&lang=js"
export * from "./LegacyOccupancyReportSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__